import React from "react";
import ExpenseDatePicker from "./ExpenseDatePicker";
import { labelStyle } from "./expenseStyles";

// Invoice date chosen when generating an invoice. Callers default it to today;
// past and future dates are both allowed, but it can't be left empty.
function InvoiceDateField({ value, onChange }) {
  return (
    <div style={{ maxWidth: 220 }}>
      <label htmlFor="invoice-date" style={labelStyle}>Invoice Date *</label>
      <ExpenseDatePicker id="invoice-date" value={value} onChange={onChange} invalid={!value} />
    </div>
  );
}

export default InvoiceDateField;
